import script from "./MyProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./MyProfile.vue?vue&type=script&setup=true&lang=js"

import "./MyProfile.vue?vue&type=style&index=0&id=7f8ee827&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f8ee827"]])

export default __exports__